import YtPlayer from 'yt-player';

export default function() {
  const players = document.querySelectorAll('.youtube-player');

  players.forEach(player => {
    player.addEventListener('initPlayer', event => {
      const targetPlayer = event.target;
      const videoId = targetPlayer.dataset.videoid;

      const playerInstance = new YtPlayer(targetPlayer, {
        annotations: false,
        related: false,
        host: 'https://www.youtube-nocookie.com'
      });

      playerInstance.load(videoId, true);
    });
  });
}
